import { useEffect, useMemo, useState } from 'react';
import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import { useDebounce } from '../../shared/hooks';
import { FazendaService } from '../services/api/FazendaService';


type TAutoCompleteOption = {
  codfaz: number;
  label: string;
}

interface IAutoCompleteFazendaProps {
  isExternalLoading?: boolean;
  codfaz?: (novoTextoselect: number | undefined) => void;
  nome?: (novoTextoselect: string | undefined) => void;
}
export const AutoCompleteFazenda01: React.FC<IAutoCompleteFazendaProps> = ({ isExternalLoading = false, codfaz, nome }) => {
  const { debounce } = useDebounce();

  const [selectedId, setSelectedId] = useState<number | undefined>();

  const [opcoes, setOpcoes] = useState<TAutoCompleteOption[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [busca, setBusca] = useState('');


  useEffect(() => {  
    setIsLoading(true);
 
    debounce(() => {  
      FazendaService.getAlllist(busca)
        .then((result) => {
          setIsLoading(false);
          if (result instanceof Error) {
          } else {
            setOpcoes(result.data.map(fazenda => ({ codfaz: fazenda.codfaz, label: fazenda.nome })));
          }
        });
    });
  }, [busca, selectedId]);

  const autoCompleteSelectedOption = useMemo(() => {
    if (!selectedId) return null;

    const selectedOption = opcoes.find(opcao => opcao.codfaz === selectedId);
    if (!selectedOption) return null;

    return selectedOption;
  }, [selectedId, opcoes]);


  return (
    <Autocomplete
      openText='Abrir'
      closeText='Fechar'
      noOptionsText='Sem opções'
      loadingText='Carregando...'

      disablePortal

      options={opcoes}
      loading={isLoading}
      disabled={isExternalLoading}
      value={autoCompleteSelectedOption}
      onInputChange={(_, newValue) => setBusca(newValue)}
      onChange={(_, newValue) => { setSelectedId(newValue?.codfaz); nome?.(newValue?.label); codfaz?.(newValue?.codfaz); setBusca('');}}
      popupIcon={(isLoading) ? <CircularProgress size={28} /> : undefined}
      renderInput={(params) => (
        <TextField
          {...params}
          size='small'
          label="Fazenda"
        />
      )}
    />
  );
};